class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this._aboveViewport = false;
    this._footerVisible = false;
    this._chatOpen = false;
  }

  connectedCallback() {
    this._submitBtn = this.querySelector('[data-sticky-submit]');
    if (this._submitBtn) {
      this._submitBtn.addEventListener('click', this._handleClick.bind(this));
    }

    const formButtons = document.querySelector('.product-form__buttons');
    const footer = document.querySelector('footer');

    if (formButtons) {
      this._observeFormButtons(formButtons);
    }
    if (footer) {
      this._observeFooter(footer);
    }

    this._syncBubble = this._syncBubble.bind(this);
    this._onChatOpen = () => {
      this._chatOpen = true;
      this._syncBubble();
    };
    this._onChatClose = () => {
      this._chatOpen = false;
      this._syncBubble();
    };
    document.addEventListener('tidioChat-open', this._onChatOpen);
    document.addEventListener('tidioChat-close', this._onChatClose);
    document.addEventListener('tidioChat-ready', this._syncBubble);
    window.addEventListener('resize', this._syncBubble);
    /* Tidio laster sent og kan re-style iframen selv — hold ønsket posisjon i synk */
    this._bubbleTimer = setInterval(this._syncBubble, 800);
  }

  _observeFormButtons(target) {
    this._formObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            const rect = entry.boundingClientRect;
            this._aboveViewport = rect.bottom < 0 || rect.top < 0;
          } else {
            this._aboveViewport = false;
          }
          this._update();
        });
      },
      { threshold: 0 }
    );
    this._formObserver.observe(target);
  }

  _observeFooter(footer) {
    this._footerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this._footerVisible = entry.isIntersecting;
          this._update();
        });
      },
      { threshold: 0, rootMargin: '200px 0px 0px 0px' }
    );
    this._footerObserver.observe(footer);
  }

  _update() {
    const show = this._aboveViewport && !this._footerVisible;
    this.dataset.stuck = show ? 'true' : 'false';
    this._syncBubble();
  }

  /* Tidio v4 rendrer chatboblen i en åpen shadow-root under #tidio-chat-root,
     så side-CSS når aldri frem — iframen må flyttes med inline !important via JS */
  _findBubble() {
    const root = document.getElementById('tidio-chat-root');
    if (root && root.shadowRoot) {
      const frame = root.shadowRoot.querySelector('#tidio-chat-iframe, iframe');
      if (frame) return frame;
    }
    return document.querySelector('#tidio-chat iframe, #tidio-chat-iframe');
  }

  _syncBubble() {
    const frame = this._findBubble();
    if (!frame) return;

    const lift = this.dataset.stuck === 'true' && !this._chatOpen && window.innerWidth < 750;

    if (lift) {
      const target = Math.round(this.offsetHeight + 8) + 'px';
      if (frame.style.getPropertyValue('bottom') !== target) {
        if (!frame.dataset.atcShifted) {
          frame.dataset.atcPrevBottom = frame.style.getPropertyValue('bottom');
          frame.dataset.atcPrevPriority = frame.style.getPropertyPriority('bottom');
          frame.dataset.atcShifted = 'true';
        }
        frame.style.setProperty('transition', 'bottom 0.3s ease', 'important');
        frame.style.setProperty('bottom', target, 'important');
      }
    } else if (frame.dataset.atcShifted) {
      if (frame.dataset.atcPrevBottom) {
        frame.style.setProperty('bottom', frame.dataset.atcPrevBottom, frame.dataset.atcPrevPriority);
      } else {
        frame.style.removeProperty('bottom');
      }
      frame.style.removeProperty('transition');
      delete frame.dataset.atcShifted;
      delete frame.dataset.atcPrevBottom;
      delete frame.dataset.atcPrevPriority;
    }
  }

  _handleClick() {
    const mainSubmit = document.querySelector('product-form button[type="submit"][name="add"]');
    if (mainSubmit) {
      mainSubmit.click();
    }
  }

  disconnectedCallback() {
    if (this._formObserver) this._formObserver.disconnect();
    if (this._footerObserver) this._footerObserver.disconnect();
    if (this._bubbleTimer) clearInterval(this._bubbleTimer);
    document.removeEventListener('tidioChat-open', this._onChatOpen);
    document.removeEventListener('tidioChat-close', this._onChatClose);
    document.removeEventListener('tidioChat-ready', this._syncBubble);
    window.removeEventListener('resize', this._syncBubble);
    this.dataset.stuck = 'false';
    this._syncBubble();
  }
}

customElements.define('sticky-atc', StickyAtc);
